import { render, staticRenderFns } from "./SpotListTable.vue?vue&type=template&id=ae84886a&scoped=true&"
import script from "./SpotListTable.vue?vue&type=script&lang=js&"
export * from "./SpotListTable.vue?vue&type=script&lang=js&"
import style0 from "./SpotListTable.vue?vue&type=style&index=0&id=ae84886a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae84886a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
